'use strict';

angular.module('webAgro1App').controller('PlantiosCtrl',
  // eslint-disable-next-line max-lines-per-function,max-params
  function($scope, $location, $q, filterFilter, AtividadesService, PlantiosService, Flash, PeriodosService,
    LoadingService, MessagesService, $routeParams) {
    const vm = this;
    vm.filters = {
      safra: null,
      gleba: null,
      atividade: null
    };
    vm.plantios = [];
    vm.atividades = [];
    vm.plantiosSelecionados = [];
    vm.periodos = [];

    vm.getPlantios = getPlantios;
    vm.changeSafra = changeSafra;
    vm.filterPlantios = filterPlantios;
    vm.inactivate = inactivate;
    vm.reactivate = reactivate;
    vm.reprocess = reprocess;
    vm.inactivatePreviousSafras = inactivatePreviousSafras;
    vm.togglePlantioSelecionado = togglePlantioSelecionado;
    vm.alterarPeriodo = alterarPeriodo;

    function togglePlantioSelecionado(plantioId) {
      const index = vm.plantiosSelecionados.indexOf(plantioId);

      if (index > -1) {
        vm.plantiosSelecionados.splice(index, 1);
      } else {
        vm.plantiosSelecionados.push(plantioId);
      }
    }

    function getPlantios() {
      return PlantiosService
        .getPlantioSimples({
          safra: vm.filters.safra,
          gleba: vm.filters.gleba,
          propriedade: $scope.$root.currentPropriedade.id
        })
        .then((plantios) => vm.serverPlantios = vm.plantios = plantios.data);
    }

    async function fetchPeriodos() {
      try {
        vm.periodos = (await PeriodosService.list()).data;
      } catch (error) {
        MessagesService.alert('Erro ao listar períodos das culturas.');
        console.error(error);
      } finally {
        LoadingService.hideLoading();
      }
    }


    function changeSafra() {
      LoadingService.showLoading();
      getPlantios()
        .then(filterPlantios)
        .catch((error) => {
          MessagesService.alert('Erro ao carregar plantios');
          console.error(error);
        })
        .finally(LoadingService.hideLoading);
    }

    function filterPlantios() {
      LoadingService.showLoading();
      // eslint-disable-next-line
      vm.plantios = vm.serverPlantios.filter((plantio) => {
        return (!vm.filters.gleba || plantio.gleba_id === vm.filters.gleba.id) &&
          (!vm.filters.atividade || plantio.atividade_id === vm.filters.atividade.id);
      });
      LoadingService.hideLoading();
    }

    function alterarPeriodo() {
      const inputOptions = vm.periodos.map((periodo) => ({
        text: periodo.descricao,
        value: periodo.codigo
      }));

      inputOptions.unshift({
        text: 'Selecione o período',
        value: ''
      });

      MessagesService.prompt(
        'Período dos plantios selecionados:',
        { inputType: 'select', inputOptions }
      ).then(async(periodoSelecionado) => {
        if (!periodoSelecionado) {
          return;
        }

        try {
          LoadingService.showLoading();

          await PlantiosService.updatePeriodo(vm.plantiosSelecionados, periodoSelecionado);
          $scope.$apply(() => vm.plantiosSelecionados = []);

          await getPlantios();
          MessagesService.alert('Alterado com sucesso o período de todos os registros vinculados com este plantio!');
        } catch (error) {
          MessagesService.alert('Erro ao atualizar períodos.');
          console.error(error);
        } finally {
          LoadingService.hideLoading();
        }
      });
    }

    function inactivate($event, plantio) {
      $event.stopPropagation();

      MessagesService
        .prompt('Data de encerramento da colheita', { value: moment().format('YYYY-MM-DD'), inputType: 'date' })
        .then((data) => {
          LoadingService.showLoading();
          PlantiosService
            .updatePlantioSimples({ plantio: plantio.id, dataEncerramento: data })
            .then(() => {
              MessagesService.alert('Plantio inativado com sucesso!');
              plantio.data_encerramento = data;
            })
            .catch((error) => {
              MessagesService.alert('Erro ao inativar plantio');
              console.error(error);
            })
            .finally(LoadingService.hideLoading);
        });
    }

    function reactivate($event, plantio) {
      $event.stopPropagation();

      MessagesService
        .prompt('Área ativa do plantio', { value: plantio.area_ativa, inputType: 'number' })
        .then((area) => {
          LoadingService.showLoading();
          PlantiosService
            .updatePlantioSimples({ plantio: plantio.id, areaAtiva: area, dataEncerramento: null })
            .then(() => {
              MessagesService.alert('Plantio reativado com sucesso!');
              plantio.data_encerramento = null;
              plantio.area_ativa = area;
            })
            .catch((error) => {
              if (error.status === 406) { // 406 = status not acceptable
                const message = 'Não foi possível reativar o plantio pois não existe área suficiente para o plantio.';
                MessagesService.alert(message);
              } else {
                MessagesService.alert('Erro ao reativar plantio');
              }
              console.error(error);
            })
            .finally(LoadingService.hideLoading);
        });
    }

    function initializeData() {
      return $q.all([
        AtividadesService.listComEmpreendimento(),
        getPlantios(),
        fetchPeriodos()
      ]).then(([atividades]) => {
        vm.atividades = atividades.data;
      });
    }

    function reprocess() {
      LoadingService.showLoading();
      PlantiosService.reprocess().then(() => {
        initializeData();
        vm.filters.gleba = vm.filters.atividade = null;
        MessagesService.alert('Plantios reprocessados com sucesso!');
      })
        .catch((error) => {
          console.error(`Error ao reprocessar plantios ${error}`);
          MessagesService.alert('Não foi possível reprocessar os plantios.');
        })
        .finally(LoadingService.hideLoading);
    }

    function inactivatePreviousSafras() {
      const msg = 'Todos os plantios das safras anteriores (exceto culturas perenes) serão inativados. Tem certeza?';
      return MessagesService.confirm(msg)
        .then(() => {
          LoadingService.showLoading();
          PlantiosService.inactivatePreviousSafras().then(() => {
            initializeData();
            vm.filters.gleba = vm.filters.atividade = null;
            MessagesService.alert('Plantios inativados com sucesso!');
          })
            .catch((error) => {
              console.error(`Error ao inativar plantios ${error}`);
              MessagesService.alert('Não foi possível inativar os plantios das safras anteriores.');
            })
            .finally(LoadingService.hideLoading);
        });
    }

    function getRouteFilters() {
      if ($routeParams.gleba) {
        vm.filters.gleba = filterFilter($scope.$root.currentPropriedade.glebas, { id: $routeParams.gleba })[0];
      }

      if ($routeParams.safra) {
        vm.filters.safra = filterFilter($scope.$root.safras, { id: $routeParams.safra })[0];
      }
    }

    LoadingService.showLoading();
    $scope.$root.initialize
      .then(function() {
        if (!$scope.$root.permissions.parametro.canManage) {
          $location.path('/');
          Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
          return;
        }

        vm.filters.safra = $scope.$root.safras.find((safra) => safra.current);

        getRouteFilters();

        initializeData();
      })
      .catch((error) => {
        MessagesService.alert('Erro ao inicializar página');
        console.error(error);
      })
      .finally(LoadingService.hideLoading);
  });
